import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { doc, updateDoc, onSnapshot } from 'firebase/firestore';
import { db } from '../firebase';
import { useUser } from '../context/UserContext';
import './ReadingStreak.css';

export default function ReadingStreak() {
  const { user } = useUser();
  const [streak, setStreak] = useState({ current: 0, best: 0, lastReadDate: null, history: [] });

  useEffect(() => {
    if (!user) return;
    const unsub = onSnapshot(doc(db, 'userLibraries', user.id), (snapshot) => {
      if (snapshot.exists()) {
        const data = snapshot.data();
        setStreak({
          current: data.streakCurrent || 0,
          best: data.streakBest || 0,
          lastReadDate: data.lastReadDate || null,
          history: data.streakHistory || [],
        });
      }
    });
    return () => unsub();
  }, [user]);

  // Mettre à jour le streak
  const updateStreak = async () => {
    if (!user) return;
    const today = new Date().toISOString().split('T')[0];
    const ref = doc(db, 'userLibraries', user.id);

    if (streak.lastReadDate === today) return; // Déjà lu aujourd'hui

    const yesterday = new Date(Date.now() - 86400000).toISOString().split('T')[0];
    let newCurrent = streak.lastReadDate === yesterday ? streak.current + 1 : 1;
    let newBest = Math.max(streak.best, newCurrent);
    let history = [...(streak.history || []), today].slice(-30);

    await updateDoc(ref, {
      streakCurrent: newCurrent,
      streakBest: newBest,
      lastReadDate: today,
      streakHistory: history,
    });
  };

  // Appeler updateStreak au montage (quand quelqu'un ouvre le reader)
  useEffect(() => {
    updateStreak();
  }, []);

  // Mini calendrier des 7 derniers jours
  const last7Days = Array.from({ length: 7 }, (_, i) => {
    const d = new Date(Date.now() - (6 - i) * 86400000);
    const dateStr = d.toISOString().split('T')[0];
    const dayLabel = ['D', 'L', 'M', 'M', 'J', 'V', 'S'][d.getDay()];
    const isActive = streak.history && streak.history.includes(dateStr);
    const isToday = dateStr === new Date().toISOString().split('T')[0];
    return { dateStr, dayLabel, isActive, isToday };
  });

  return (
    <div className="streak-widget">
      <div className="streak-header">
        <div className="streak-fire">
          <span className="streak-fire-emoji">🔥</span>
          <span className="streak-fire-count">{streak.current}</span>
        </div>
        <div className="streak-info">
          <p className="streak-label">{streak.current > 1 ? streak.current + ' jours consécutifs' : streak.current === 1 ? "Tu lis aujourd'hui !" : 'Lis pour commencer !'}</p>
          <p className="streak-best">Record : {streak.best} 🏆</p>
        </div>
      </div>
      <div className="streak-days">
        {last7Days.map(day => (
          <div key={day.dateStr} className={'streak-day ' + (day.isActive ? 'streak-day-active' : '') + (day.isToday ? ' streak-day-today' : '')}>
            <span className="streak-day-label">{day.dayLabel}</span>
            <div className="streak-day-dot">
              {day.isActive && <motion.div className="streak-day-fill" initial={{ scale: 0 }} animate={{ scale: 1 }} />}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}